import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SdModalService, SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2';
import { AddCompanyModalComponent } from '../add-company-modal';

@Component({
  selector: 'sd-add-company-button',
  imports: [SdvorIconComponent, NgTemplateOutlet, RouterLink],
  templateUrl: './add-company-button.component.html',
  styleUrls: ['./add-company-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddCompanyButtonComponent {
  readonly size = input<'xs' | 's'>('xs');
  readonly action = input<'modal' | 'redirect'>('modal');

  protected readonly iconTypes = IconTypes;

  private readonly modalService = inject(SdModalService);

  openModal(): void {
    this.modalService.open(AddCompanyModalComponent, {
      modalType: { xxs: 'fullscreen', md: 'compact' },
      maxWidth: { md: '430px', lg: '500px' },
      ignoreOutsideClick: true,
    });
  }
}
